<template>
  <div class="input-modal-wrapper" ref="wrapper">
    <div class="input-modal overlay" v-show="visible" @touchmove="onModalTouch">
      <div class="input-form" ref="inputModalRef">
        <div class="title">
          <span>自定义发音： </span>
          <span class="arrow-btn" @click="onCloseClick">
            <van-icon name="arrow-down" />
          </span>
        </div>
        <div class="input-wrapper">
          <van-field
            ref="input"
            v-model="userInput"
            :clearable="true"
            type="text"
            placeholder="请输入拼音对应的英文字母"
            enterkeyhint="done"
            @focus="onInputFocus"
            @blur="onInputBlur"
            @input="onInput"
          />
        </div>
        <ul class="tone-list" ref="toneListRef">
          <li
            class="tone-item"
            v-for="(item, index) in toneList"
            :key="index"
            @click="onToneSelect(index)"
          >
            <span>{{ item.value }}</span>
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import findTonesByPrifix from "./multi-tone-dict";
import inputModalMixin from "@/mixins/input-modal-mixin";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [inputModalMixin],
  data() {
    return {
      userInput: "",
      toneList: [],
    };
  },
  mounted() {
    document.body.appendChild(this.$refs.wrapper);
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible) {
          this.reset();
          this.showKeyboard();
        }
      },
    },
  },
  methods: {
    // 重置组件状态
    reset() {
      this.userInput = "";
      this.toneList = [];
    },
    // 放弃输入
    onCloseClick() {
      // 默认会触发blur了
    },
    // 选定声调
    onToneSelect(index) {
      this.$emit("update:visible", false);
      this.$emit("confirm", this.toneList[index].value);
    },
    // 聚焦事件
    onInputFocus() {
      this.showInputModal({
        keyboardType: this.type,
        adjustInputModalHeight: true,
        minTopOffset: 100,
      });
    },
    // 失焦事件
    onInputBlur() {
      // 到下个循环再隐藏弹窗，防止onToneSelect的点击事件不触发
      setTimeout(() => {
        this.$emit("update:visible", false);
      });
    },
    // 输入事件
    onInput() {
      const toneList = findTonesByPrifix(this.userInput);
      this.toneList = toneList.map(([, value, name]) => {
        return { value, name };
      });
    },
    // 弹窗touch事件
    onModalTouch(e) {
      this.stopScrollChaining(e, this.$refs.toneListRef);
    },
    // 安卓键盘收起
    onAndroidKeyboardDownEvent() {
      this.onInputBlur();
    },
  },
};
</script>
<style lang="less" scoped>
.input-modal {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  &.overlay {
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}
.input-form {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 580px;
  padding: 18px 0;
  position: absolute;
  left: 0;
  right: 0;
  // top: 0;
  z-index: 2000;
  background: #f2f2f7;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 32px;
    margin-bottom: 5px;
    height: 60px;
    font-size: 28px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 500;
    color: #333;
    line-height: 40px;
    .arrow-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      width: 48px;
      height: 44px;
    }
  }
  .input-wrapper {
    padding: 0 32px;
    /deep/.van-cell {
      padding-top: 0;
      padding-bottom: 0;
      padding-right: 24px;
      height: 64px;
      align-items: center;
      border-radius: 10px;
    }
    /deep/.van-field__value {
      height: 48px;
    }
    /deep/.van-field__control {
      font-size: 28px;
      font-family: 'HarmonyOS_Sans_SC';
      font-weight: 400;
      color: #333;
    }
  }
}

.tone-list {
  flex: 1;
  overflow: auto;
  margin-top: 16px;
  padding: 0 44px;
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  letter-spacing: 1px;
  span:last-child {
    color: #b8b8b8;
  }
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 17px;
    padding-right: 12px;
    height: 72px;
    &:not(:first-child) {
      border-top: 1px solid #dde2e7;
    }
  }
}
</style>